'use client';

import getLocalizedNavigationSpecialEventsLinks from '../../../../data/navigationSpecialEventsLinks';

import MobileNavigationSpecialEventsLink from './MobileNavigationSpecialEventsLink';

type Props = {
  onClickAction: () => void;
};

export default function MobileNavigationSpecialEventsLinks({ onClickAction }: Props) {
  const localizedSpecialEventsLinks = getLocalizedNavigationSpecialEventsLinks();

  return (
    <>
      {localizedSpecialEventsLinks.map((link) => {
        return (
          <MobileNavigationSpecialEventsLink
            key={link.href}
            link={link}
            onClickAction={onClickAction}
          />
        );
      })}
    </>
  );
}
